import { useState, useEffect } from 'react';

/**
 * Hybrid responsive hook using window resize listener
 */
export const useHybridResponsive = () => {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return {
    isMobile: width < 640,
    isTablet: width >= 640 && width < 1024,
    isDesktop: width >= 1024,
  };
};

/**
 * Hook for responsive values
 */
export const useResponsiveValue = <T,>(values: {
  base?: T;
  sm?: T;
  md?: T;
  lg?: T;
  xl?: T;
  '2xl'?: T;
}): T | undefined => {
  const { isMobile, isTablet, isDesktop } = useHybridResponsive();

  if (isMobile) return values.base || values.sm;
  if (isTablet) return values.md || values.sm;
  if (isDesktop) return values.lg || values.xl || values['2xl'];
  return values.base;
};